'use client';

import { useLanguage } from '@bells/core/i18n';
import { authQuote } from '@bells/i18n/messages';
import { baseLocale } from '@bells/i18n/runtime';
import { Logo } from '@bells/ui/icons/logo';
import Link from 'next/link';
import { type PropsWithChildren } from 'react';

export default function AuthLayout({ children }: PropsWithChildren) {
  const { language } = useLanguage();
  return (
    <>
      <div className='min-h-webkit-fill relative flex h-[100vh] px-6 lg:max-w-none lg:px-0'>
        <div className='relative flex h-full flex-1 flex-col py-6 lg:px-6'>
          <Link
            prefetch={false}
            href={`/${language == baseLocale ? '' : language}`}
            className='text-red z-20 flex items-center text-brand no-underline'
          >
            <Logo size={40}></Logo>
          </Link>
          <div className='mx-auto flex h-full w-full flex-col place-content-center justify-center sm:max-w-lg'>
            {children}
          </div>
        </div>
        <div className='bg-image relative hidden h-full flex-col bg-foreground p-10 text-white dark:border-r lg:flex lg:w-[50vw] 2xl:w-[60vw]'>
          <div className='relative z-20 mt-auto'>
            <blockquote className='space-y-8'>
              <p className='text-6xl font-medium'>{authQuote()}</p>
              <footer className='text-xl font-light'>Bell Bennett</footer>
            </blockquote>
          </div>
        </div>
        <style jsx>{`
          .bg-image {
            background:
              linear-gradient(
                0deg,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0.1) 20%
              ),
              url(/assets/signin.webp);

            background-repeat: no-repeat;
            background-size: cover;
          }
        `}</style>
      </div>
    </>
  );
}
